<script>
    import Spinner from '../../Spinner.svelte';
    import {submit} from '../../../utils.js';
    import {updateLocalRoles, generateHeader} from './utils.js';
    import {roles, activityVersion} from '../workspacesStore.js';
    import {sgettext} from '../../../i18n.js';

    export let actionApi = '';

    let saving = false;
    let name = '';
    let focused = false;

    function onFocus(event) {
        focused = true;
    }

    function onBlur(event) {
        focused = false;
        if(name){
            save();
        }
    }

    async function save() {
        saving = true;
        const data = {
            name,
            activity_version_id: $activityVersion.id
        };
        const resp = await submit(actionApi, 'POST', data);

        if (resp.ok) {
            const json = await resp.json();
            json.header = generateHeader(0, 0);
            roles.set(updateLocalRoles($roles, [json]));
            name = '';
        }

        saving = false;
    }

    function onKeyUp(event) {
        if (event.key === 'Enter') {
            save();
        }
    }
</script>

<style>
    .add-role-wrapper {
        display: flex;
        background-color: #6C757D;
        padding: 5px 5px 5px 10px;
        color: #dddddd;
    }

    .add-role-wrapper input {
        background-color: transparent;
        border: none;
        color: #dddddd;
        width: 100%;
    }

    .add-role-wrapper input:focus {
        outline: none;
    }

    .add-role-wrapper.focused {
        border: 1px solid #018982;
        background-color: #edf8f6;
        color: #454545;
    }

    .add-role-wrapper.focused input {
        color: #454545;
    }

    ::placeholder {
        color: #dddddd;
    }

    .icon {
        margin-right: 5px;
    }

</style>

<div
        class:focused
        class="add-role-wrapper static">
    <span class="icon"><i class="fas fa-edit"></i></span>
    <input
            bind:value={name}
            placeholder={sgettext("$$ADD_ROLE_1$$")}
            border={false}
            on:focus={onFocus}
            on:blur={onBlur}
            on:keyup={onKeyUp}
    />
    {#if saving}
        <div class="spinner">
            <Spinner size="small" inline={true}/>
        </div>
    {/if}
</div>
